import { FETCH_PURCHASE_STATUS } from '../actions/actionTypes'

export const purchaseStatus = (state = {}, action) => {
    switch (action.type) {
        case FETCH_PURCHASE_STATUS:
            return {
                ...action.purchaseStatus,
                loading: false
            }
        default:
            return state
    }
}

export default purchaseStatus;



// WEBPACK FOOTER //
// ./src/reducers/purchaseStatusReducer.js